<template>
  <div class="old-union">
    <div class="notice" v-if="noticeData && noticeData.noticeContent">
      <div class="notice__wrapper">
        <notice
          :noticeData="noticeData"
          :unionHead="unionHead"
          :noticeInit="noticeInit"
        >
          <span class="notice__label" slot="noticeLabel">
            <i class="notice__icon"></i>
          </span>
        </notice>
      </div>
    </div>
    <old-union-bar
      :unionHead="unionHead"
      :loginData="loginData"
      v-if="unionHead && loginData"
    ></old-union-bar>
    <old-union-body :unionHead="unionHead" v-if="unionHead"></old-union-body>
    <old-union-menu :unionHead="unionHead" v-if="unionHead"></old-union-menu>
  </div>
</template>

<script>
import OldUnionBar from "./OldUnionBar";
import OldUnionBody from "./OldUnionBody";
import OldUnionMenu from "./OldUnionMenu";

export default {
  components: {
    OldUnionBar,
    OldUnionBody,
    OldUnionMenu,
    Notice: () => import("./Notice"),
  },
  data() {
    return {
      unionHead: null,
      loginData: null,
      noticeData: null,
      noticeInit: {
        color: "#666",
        col1: 1,
        col2: 23,
      },
    };
  },
  created() {
    // 获取公告内容
    this.getNoticeData();

    // 获取登录状态
    this.getLoginStatus();

    // 获取老工会信息
    this.getLogo();
  },
  methods: {
    getLogo() {
      this.apis.headerApi.getLogo().then((res) => {
        this.unionHead = res;
      });
    },
    getLoginStatus() {
      this.apis.headerApi.getLoginStatus().then((res) => {
        if (res.loginFlag) {
          this.loginData = res;
        } else {
          window.df_sdk_common.location.href = res.loginUrl;
        }
      });
    },
    getNoticeData() {
      this.apis.headerApi.getNotice().then((res) => {
        this.noticeData = res;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.notice {
  height: 40px;
  line-height: 40px;
  background-color: #ebf5fa;
  &__wrapper {
    .wrapper();
  }
  &__label {
    > span {
      margin-left: 5px;
      font-size: 14px;
    }
  }
  &__icon {
    display: inline-block;
    vertical-align: middle;
    position: relative;
    top: -2px;
    background: url("./imgs/notice.png") no-repeat;
    width: 19px;
    height: 17px;
    background-size: cover;
  }
}
</style>
